import { useLastShowWhatsNewVersion } from '@/utils/fetchers/base'
import { useIsMobile } from '@/utils/hooks/useMediaQuery'
import { showWhatsNewModal } from '@/utils/whatsNew'
import { IconSparkles } from '@tabler/icons-react'
import clsx from 'clsx'
import { Variants } from 'motion/react'
import { HTMLAttributes, useMemo } from 'react'
import pkg from '../../package.json'
import ClickWrapper from './ClickWrapper'
import styles from './WhatsNewTip.module.css'

// 处理图标和渐变的子组件
function GradientIcon() {
	return (
		<>
			<IconSparkles size={24} className={styles.icon} />
			{/* 添加 SVG 渐变定义 */}
			<svg width="0" height="0">
				<defs>
					<linearGradient id="icon-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stopColor="var(--tint-jike-yellow)" />
						<stop offset="100%" stopColor="var(--tint-jike-blue)" />
					</linearGradient>
				</defs>
			</svg>
		</>
	)
}

// 处理内容的子组件
function Content() {
	return (
		<div className={styles.content}>
			<div className={styles.contentTitle}>What&#39;s New</div>
		</div>
	)
}

export default function WhatsNewTip({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
	const [lastShowWhatsNewVersion, setLastShowWhatsNewVersion] = useLastShowWhatsNewVersion()
	const isMobile = useIsMobile()

	const animationProps: Variants = useMemo(
		() => ({
			initial: {
				opacity: 0,
				y: '100%',
			},
			animate: {
				opacity: 1,
				y: lastShowWhatsNewVersion === pkg.version ? '100%' : 0,
				transition: {
					duration: 0.6,
					delay: 3,
					type: 'spring',
					damping: 20,
				},
			},
		}),
		[lastShowWhatsNewVersion]
	)

	if (isMobile) {
		return null
	}

	return (
		<ClickWrapper
			whileTap={{
				scale: 0.98,
			}}
			onClick={() => {
				showWhatsNewModal()
				setLastShowWhatsNewVersion(pkg.version)
			}}
			className={clsx(styles.wrapper, className)}
			{...animationProps}
		>
			<GradientIcon />
			<Content />
		</ClickWrapper>
	)
}
